import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const Hyperlink = styled.a`
  color: ${props => props.theme.highlightColor};
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

Hyperlink.defaultProps = {
  target: '_blank',
  rel: 'noreferrer',
};

Hyperlink.propTypes = {
  target: PropTypes.string,
  rel: PropTypes.string,
};

export default Hyperlink;
